/* Fix My Posture Bundle product page.

   1. EVERY SELECTION LANDS ON A VARIANT THAT EXISTS.

      The Bundle sells 97 of the 120 Insole Size / Gender / Width combinations.
      For example US 5 / Women / Standard does not exist, and the page opens on
      US 5 / Men / Standard. When a change lands on a combination that does not
      exist, the theme renders the buy box with no variant: the form's
      name="id" becomes empty, quantity and express checkout are hidden, and
      Add to cart fails with "Cannot find variant".

      The template's loader section renders the list of combinations that
      exist. When Insole Size, Gender or Width changes, this checks that list
      in the capture phase, before the theme's own handler reads the selection,
      and if the combination does not exist it moves Insole Size to the nearest
      size that does, larger first as the size guide advises. The theme then
      requests a real variant, so name="id" is never emptied. The variant id is
      always the one Shopify renders for the chosen options. This file never
      writes it.

   2. ACTIVATOR SIZE READS THE SAME IN BOTH BUY BOXES.

      SC Product Options' dropdown in the top box and the theme's Custom
      property dropdown in the lower box read "Choose size", then Small,
      Medium, Large with millimetres from the size guide. Display text and
      order only: values stay "", "Small", "Medium", "Large".

      Each box opens on Medium (Master, 2026-10-17), once, while still empty.
      A size the shopper picks is never changed.

   3. "View the size guide" in the lower buy box.

   4. Gallery photos get their own alt text, from the template's loader section.

   Apart from opening the Activator Size boxes on Medium, it never changes an
   option value, the product form, quantity, Add to cart, the payment buttons,
   the cart or checkout. */
(function () {
  'use strict';

  if (window.fmpProductPageLoaded) { return; }
  window.fmpProductPageLoaded = true;

  /* ---------- 1. Nearest existing variant ---------- */

  function hasVariant(picker) {
    var data = picker.querySelector('[data-js-variant-data]');
    if (!data) { return true; }
    try { return JSON.parse(data.textContent) !== null; } catch (e) { return true; }
  }

  function exists(opt) {
    return !!(opt && opt.getAttribute('data-variant-id'));
  }

  /* The first option row is Insole Size. Search larger sizes first, then
     smaller, for one that exists with the current Gender and Width. */
  function nearestSize(select) {
    var opts = select.options;
    var at = select.selectedIndex;
    for (var up = at + 1; up < opts.length; up++) { if (exists(opts[up])) { return opts[up]; } }
    for (var down = at - 1; down >= 0; down--) { if (exists(opts[down])) { return opts[down]; } }
    return null;
  }

  /* The combinations that exist, rendered by Shopify into the template's own
     loader section on every page load: [[Insole Size, Gender, Width], ...]. */
  var SEP = '\u0001';
  function readCombos() {
    var el = document.querySelector('script[data-fmp-variants]');
    if (!el) { return null; }
    try {
      var set = {};
      JSON.parse(el.textContent).forEach(function (v) { set[v.join(SEP)] = true; });
      return set;
    } catch (e) { return null; }
  }

  /* BEFORE THE THEME REACTS. This listener runs in the capture phase, ahead of
     the theme's own change handler on the same element. If the new selection is
     a combination that does not exist, Insole Size is moved to the nearest size
     that exists with the chosen Gender and Width, larger first, in the same
     step. The theme then reads a real combination and requests a real variant,
     so name="id" is never emptied. No event is fired and the id is not touched. */
  function preempt(picker, combos) {
    picker.addEventListener('change', function (e) {
      if (!e.target || e.target.tagName !== 'SELECT') { return; }
      var selects = picker.querySelectorAll('select[data-js-product-variant-container]');
      if (selects.length !== 3) { return; }
      var values = Array.prototype.map.call(selects, function (s) { return s.value; });
      if (combos[values.join(SEP)]) { return; }
      var size = selects[0];
      var at = size.selectedIndex;
      var fits = function (i) {
        var v = values.slice();
        v[0] = size.options[i].value;
        return !!combos[v.join(SEP)];
      };
      var pick = -1;
      for (var up = at + 1; up < size.options.length && pick < 0; up++) { if (fits(up)) { pick = up; } }
      for (var down = at - 1; down >= 0 && pick < 0; down--) { if (fits(down)) { pick = down; } }
      if (pick >= 0) { size.selectedIndex = pick; }
    }, true);
  }

  function watch(picker, combos) {
    if (picker.hasAttribute('data-fmp-watched')) { return; }
    picker.setAttribute('data-fmp-watched', '');
    if (combos) { preempt(picker, combos); }
    var corrections = 0;

    /* Backstop only: if a render still arrives with no variant, move to the
       nearest size the theme marks as existing and let the theme load it. */
    picker.addEventListener('VARIANT_CHANGE', function () {
      if (hasVariant(picker)) { corrections = 0; return; }
      if (corrections >= 2) { return; }
      var size = picker.querySelector('select[data-js-product-variant-container]');
      var target = size && nearestSize(size);
      if (!target) { return; }
      corrections++;
      size.value = target.value;
      size.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- 2. Activator Size, both buy boxes ----------
     Top box: SC Product Options' dropdown. Lower box: the theme's Custom property
     dropdown. Both are named properties[...] and both read the same:

       Choose size
       Small, 33 millimetres or less
       Medium, 34 to 37 millimetres
       Large, 38 millimetres or more

     Only the TEXT shown and the ORDER listed change. Option VALUES stay "",
     "Small", "Medium", "Large", so the size added to the order is unchanged.
     This is safe for the app, read from its own code (product-options-11
     options.js): it reads the choice only as select.value (getValue), raises
     "This option is required" only when that value is empty (validateOption),
     never reads option text, selectedIndex or selectedOptions, and never watches
     the page. The app draws its dropdown after load, so each pass re-runs when
     the product area changes; a pass that finds everything right writes
     nothing, so it cannot loop. No event is fired. The only selection made is
     the Medium default below. */

  var SIZE_WORD = /^(small|medium|large)\b/;
  var FALLBACK_ORDER = ['small', 'medium', 'large'];

  function readGuide() {
    var order = [];
    var measure = {};
    document.querySelectorAll('dialog.ppro-sg table tbody tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('th, td');
      if (cells.length < 2) { return; }
      var name = cells[0].textContent.trim().toLowerCase();
      var value = cells[1].textContent.trim();
      if (SIZE_WORD.test(name) && value && !measure[name]) { order.push(name); measure[name] = value; }
    });
    return { order: order.length ? order : FALLBACK_ORDER, measure: measure };
  }

  function sizeOf(opt) {
    var m = opt.value.trim().toLowerCase().match(SIZE_WORD);
    return m ? m[1] : '';
  }

  function isSizeSelect(select) {
    var sized = Array.prototype.filter.call(select.options, function (o) { return o.value; });
    return sized.length >= 2 && sized.every(function (o) { return sizeOf(o); });
  }

  function setText(opt, text) {
    if (opt.textContent !== text) { opt.textContent = text; }
  }

  function tidySize(select, guide) {
    var opts = Array.prototype.slice.call(select.options);
    opts.forEach(function (opt) {
      if (!opt.value) { setText(opt, 'Choose size'); return; }
      var mm = guide.measure[sizeOf(opt)];
      setText(opt, mm ? opt.value + ', ' + mm : opt.value);
    });
    var rank = function (opt) {
      if (!opt.value) { return -1; }
      var i = guide.order.indexOf(sizeOf(opt));
      return i === -1 ? guide.order.length + opts.indexOf(opt) : i;
    };
    var wanted = opts.slice().sort(function (a, b) { return rank(a) - rank(b); });
    if (wanted.every(function (opt, i) { return opt === opts[i]; })) { return; }
    var chosen = select.value;
    wanted.forEach(function (opt) { select.appendChild(opt); });
    /* Guard only: moving options keeps the selection. */
    if (select.value !== chosen) { select.value = chosen; }
  }

  /* Each Activator Size box opens on Medium (Master, 2026-10-17). A box is set
     once, when this file first sees it, and only if it is still empty, so a
     size restored by the browser is kept. After the shopper has changed a box
     themselves, a box that comes back empty is left empty for the required
     check: their choice is never replaced by Medium. Only select.value is set,
     to the box's own "Medium" option, which is what the app and the theme read
     at Add to cart. No event is fired. */
  var DEFAULT_SIZE = 'medium';
  var picked = {};
  function sizeKey(select) {
    var section = select.closest('.shopify-section');
    return (section ? section.id : '') + '|' + select.name;
  }
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (select && select.tagName === 'SELECT' && /^properties\[/.test(select.name || '')) {
      picked[sizeKey(select)] = true;
    }
  }, true);
  function defaultSize(select) {
    if (select.hasAttribute('data-fmp-default')) { return; }
    select.setAttribute('data-fmp-default', '');
    if (select.value || picked[sizeKey(select)]) { return; }
    var medium = Array.prototype.filter.call(select.options, function (opt) {
      return sizeOf(opt) === DEFAULT_SIZE;
    })[0];
    if (medium) { select.value = medium.value; }
  }

  function tidyAllSizes() {
    var guide = readGuide();
    document.querySelectorAll('.product-text select[name^="properties["]').forEach(function (select) {
      if (isSizeSelect(select)) { tidySize(select, guide); defaultSize(select); }
    });
  }

  var queued = false;
  function scheduleTidy() {
    if (queued) { return; }
    queued = true;
    window.requestAnimationFrame(function () { queued = false; tidyAllSizes(); applyAlts(); });
  }

  /* ---------- 3. "View the size guide" in the lower buy box ----------
     The Featured product section offers no block that can hold a button, so the
     link is added here, right aligned above that box's picker, exactly like the
     top one. Same words as the top link, read from it, and it opens the one Size
     Guide dialog already on the page through the component's own
     data-ppro-sg-open hook. It is a plain button outside every form: it reads and
     writes no form, variant, quantity, Add to cart, payment button, cart or
     checkout. The lower box sits far below the first screen, so adding it after
     load moves nothing the shopper is looking at. */
  function addGuideLink() {
    var dialog = document.querySelector('dialog.ppro-sg[id]');
    var words = document.querySelector('.product-text .ppro-sg-trigger span');
    if (!dialog || !words) { return; }
    document.querySelectorAll('.product-text > product-variants:not([data-main-product-page-variants])').forEach(function (picker) {
      var before = picker.previousElementSibling;
      if (before && before.hasAttribute('data-fmp-sg-link')) { return; }
      var wrap = document.createElement('div');
      wrap.className = 'ppro-sg-trigger-wrap';
      wrap.setAttribute('data-align', 'right');
      wrap.setAttribute('data-fmp-sg-link', '');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ppro-sg-trigger';
      button.setAttribute('data-ppro-sg-open', dialog.id);
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', dialog.id);
      var label = document.createElement('span');
      label.textContent = words.textContent.trim();
      button.appendChild(label);
      wrap.appendChild(button);
      picker.parentNode.insertBefore(wrap, picker);
    });
  }

  /* ---------- 4. Gallery alt text ----------
     The product's photos carry no alt text of their own, so the theme falls back
     to the product title on every one. The descriptions live in the template's
     loader section, keyed by image file name, and are applied here to the two
     product galleries on this page, the slides and their thumbnails. Only a
     blank alt or the title fallback is replaced, so alt text entered on a photo
     in Shopify admin always wins. The header menu's images are not touched. */
  var altMap = null;
  var altFallback = '';
  function readAlts() {
    var el = document.querySelector('script[data-fmp-alts]');
    if (!el) { return; }
    try { altMap = JSON.parse(el.textContent); } catch (e) { altMap = null; }
    altFallback = el.getAttribute('data-fmp-fallback') || '';
  }
  function applyAlts() {
    if (!altMap) { return; }
    document.querySelectorAll('product-page .product-gallery img').forEach(function (img) {
      var name = (img.getAttribute('src') || '').split('?')[0].split('/').pop();
      var alt = altMap[name];
      if (!alt) { return; }
      var current = img.getAttribute('alt') || '';
      if (current === alt || (current && current !== altFallback)) { return; }
      img.setAttribute('alt', alt);
    });
  }

  function boot() {
    readAlts();
    applyAlts();
    addGuideLink();
    var combos = readCombos();
    document.querySelectorAll('product-variants[data-variants="3"][data-type="select"]').forEach(function (picker) {
      watch(picker, combos);
    });

    tidyAllSizes();
    var main = document.getElementById('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(scheduleTidy).observe(main, { childList: true, subtree: true });
    }
    window.addEventListener('load', scheduleTidy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
